import { ia } from 'lib/helpers/utility';

import Popover from 'components/shared/Popovers/Popover/Popover';

import ActionsButton from './components/ActionsButton';
import NewSave from './components/NewSave';

const Actions = ({
  saveButton,
  setSaveButton,
  saveInput,
  setSaveInput,
  save,
  appliedFilter,
  filtersData,
  applyFilter,
  makeDefault,
  deleteFilter
}) => {
  const actionOptions = [
    {
      label: 'Save',
      icon: 'save-mono',
      onClick: () => {
        setSaveButton(true);
      }
    },
    {
      label: 'Saved filters',
      icon: 'history-mono',
      children: ia(filtersData)
        ? filtersData.map((filter) => ({
            label: filter.name,
            children: [
              { label: 'Apply', onClick: () => applyFilter(filter) },
              {
                label: filter.is_default ? 'Remove default' : 'Set as default',
                onClick: () => makeDefault(filter.id, !filter.is_default)
              },
              { label: 'Delete', onClick: () => deleteFilter(filter.id) }
            ]
          }))
        : null
    },
    {
      label: 'Reset & Save',
      icon: 'rotate-ccw-mono',
      onClick: () => makeDefault(filtersData[0]?.id, !filtersData[0]?.is_default)
    }
  ];

  return (
    <>
      <Popover
        isFixed
        isBorder={false}
        position="right"
        customButtonTrigger={<ActionsButton appliedFilter={appliedFilter} />}
        options={actionOptions}
      />
      <NewSave
        saveButton={saveButton}
        setSaveButton={setSaveButton}
        saveInput={saveInput}
        setSaveInput={setSaveInput}
        save={save}
        filtersData={filtersData}
      />
    </>
  );
};

export default Actions;
